import "./App.css";
import Navbar from "./components/Navbar";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Sobre from "./pages/Sobre/sobre";
import Portfolio from "./pages/Portfolio/portfolio";
import Servicos from "./pages/Servicos/servicos";
import Home from "./pages/Home/Home";
import FaleConosco from "./pages/FaleConosco/FaleConosco";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/inicio" element={<Home />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/servicos" element={<Servicos />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/inicio" element={<FaleConosco />} />
      </Routes>
    </Router>
  );
}

export default App;
